export const DEFAULT_PAGINATION = {
  PAGE_SIZE: 20,
};

export const CONTAINER_ID = 'inventory-mf-application-container';
